module.exports = __webpack_public_path__ + "img/logo_mapofzones.1e74b5d8.png";